/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Device_SignalsInputs */

const vi_vehicle_gps_device_signals = /** @type {(inputs: Vehicle_Gps_Device_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tín hiệu thiết bị`)
};

/**

* @param {Vehicle_Gps_Device_SignalsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_device_signals = /** @type {((inputs?: Vehicle_Gps_Device_SignalsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Device_SignalsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_device_signals(inputs)
});